import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { useState, useContext, createContext } from 'react';
import { jsx } from 'react/jsx-runtime';

var initalState = {
  focusedIndex: -1,
  initialFocus: null,
  onClose: null
};
var MenuContext = /*#__PURE__*/createContext(initalState);
var MenuProvider = function MenuProvider(_ref) {
  var children = _ref.children;
  var _useState = useState(initalState),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var focusedIndex = state.focusedIndex,
    initialFocus = state.initialFocus,
    onClose = state.onClose;
  var setFocusedIndex = function setFocusedIndex(i) {
    setState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        focusedIndex: i
      });
    });
  };
  var setInitialFocus = function setInitialFocus(initialFocus) {
    setState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        initialFocus: initialFocus
      });
    });
  };
  var setOnClose = function setOnClose(onClose) {
    var onCloseHelper = function onCloseHelper() {
      setFocusedIndex(-1);
      setInitialFocus(null);
      onClose();
    };
    setState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        onClose: onCloseHelper
      });
    });
  };
  var value = {
    setFocusedIndex: setFocusedIndex,
    focusedIndex: focusedIndex,
    setInitialFocus: setInitialFocus,
    initialFocus: initialFocus,
    setOnClose: setOnClose,
    onClose: onClose
  };
  return /*#__PURE__*/jsx(MenuContext.Provider, {
    value: value,
    children: children
  });
};
var useMenu = function useMenu() {
  return useContext(MenuContext);
};

export { MenuProvider, useMenu };
